import * as IF from "infrontjs";
import template from './template.html';

class MainMenu extends HTMLElement
{
    static get observedAttributes()
    {
        return [ 'active-item' ];
    }

    constructor()
    {
        super();
        this._isConnected = false;
    }

    connectedCallback()
    {
        if ( false === this._isConnected )
        {
            this.root = this;
            this.app = IF.App.get();
            this.render();

            this._isConnected = true;
        }
    }

    disconnectedCallback()
    {}

    attributeChangedCallback( name, oldVal, newVal )
    {}

    render()
    {
        this.root.innerHTML = this.app.view.getHtml(
            template,
            {
                activeItem : this.getAttribute( 'active-item' ),
                isNativeMobile : this.app.isNativeMobile()
            }
        );
    }

}

customElements.define('main-menu', MainMenu );
